module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "odiv"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.routerID),
      expression: "!routerID"
    }],
    staticClass: "p1"
  }, [_vm._v("  新增入库")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.routerID),
      expression: "routerID"
    }],
    staticClass: "p1"
  }, [_vm._v("  修改详情")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": " 供应商:"
    }
  }, [_c('el-input', {
    class: {
      margintop: _vm.active
    },
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "供应商",
      "clearable": ""
    },
    model: {
      value: (_vm.supplier),
      callback: function($$v) {
        _vm.supplier = $$v
      },
      expression: "supplier"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " 供应商电话:"
    }
  }, [_c('el-input', {
    class: {
      margintop: _vm.active
    },
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "供应商电话",
      "clearable": ""
    },
    model: {
      value: (_vm.supplierPhone),
      callback: function($$v) {
        _vm.supplierPhone = $$v
      },
      expression: "supplierPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注:"
    }
  }, [_c('el-input', {
    class: {
      margintop: _vm.active
    },
    attrs: {
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.remarks),
      callback: function($$v) {
        _vm.remarks = $$v
      },
      expression: "remarks"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "98%",
      "border": "0",
      "margin-left": "18px"
    },
    attrs: {
      "data": _vm.item_1,
      "stripe": "",
      "row-key": "rowkey",
      "border": "",
      "header-cell-style": _vm.tableHeaderColor
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "auto"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "value",
      "label": "药品名称",
      "width": "auto"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unit",
      "label": "单位",
      "width": "auto"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderNumber",
      "label": "订单数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-input', {
          class: {
            input: _vm.active
          },
          on: {
            "input": function($event) {
              return _vm.handleOrderNumberChange(row.id, $event)
            }
          },
          model: {
            value: (row.orderNumber),
            callback: function($$v) {
              _vm.$set(row, "orderNumber", $$v)
            },
            expression: "row.orderNumber"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inNumber",
      "label": "入库数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-input', {
          class: {
            input: _vm.active
          },
          on: {
            "input": function($event) {
              return _vm.handleInNumberChange(row.id, $event)
            }
          },
          model: {
            value: (row.inNumber),
            callback: function($$v) {
              _vm.$set(row, "inNumber", $$v)
            },
            expression: "row.inNumber"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "costPrice",
      "label": "成本价(￥)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-input', {
          class: {
            input: _vm.active
          },
          on: {
            "input": function($event) {
              return _vm.handleCostPriceChange(row.id, $event)
            }
          },
          model: {
            value: (row.costPrice),
            callback: function($$v) {
              _vm.$set(row, "costPrice", $$v)
            },
            expression: "row.costPrice"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "成本合计(￥)",
      "prop": "sumAmount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n                " + _vm._s(row.costPriceTotal) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "batchNumber",
      "label": "批号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-input', {
          on: {
            "input": function($event) {
              return _vm.handleBatchNumberChange(row.id, $event)
            }
          },
          model: {
            value: (row.batchNumber),
            callback: function($$v) {
              _vm.$set(row, "batchNumber", $$v)
            },
            expression: "row.batchNumber"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "有效期",
      "width": "180",
      "prop": "effectiveDates"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-date-picker', {
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "type": "date",
            "placeholder": "选择日期",
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd"
          },
          model: {
            value: (row.effectiveDates),
            callback: function($$v) {
              _vm.$set(row, "effectiveDates", $$v)
            },
            expression: "row.effectiveDates"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.deleteRow(scope.$index, _vm.item_1)
            }
          }
        }, [_vm._v("删除\n                ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-autocomplete', {
    class: {
      autocomplete: _vm.active
    },
    staticStyle: {
      "width": "98%",
      "margin-left": "18px"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "请搜索"
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.state),
      callback: function($$v) {
        _vm.state = $$v
      },
      expression: "state"
    }
  }), _vm._v(" "), _c('el-upload', {
    staticClass: "upload-demo",
    staticStyle: {
      "width": "98%",
      "margin-left": "18px",
      "margin-top": "10px"
    },
    attrs: {
      "action": "/api/upload/singlefile/invoice",
      "on-preview": _vm.handlePreview,
      "file-list": _vm.fileList2,
      "list-type": "picture",
      "headers": _vm.headers,
      "on-success": _vm.onSuccess,
      "on-remove": _vm.onRemove
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传发票")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传jpg/png文件")])], 1), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.routerID),
      expression: "this.routerID"
    }],
    attrs: {
      "type": "info",
      "plain": true
    },
    on: {
      "click": _vm.add_check
    }
  }, [_vm._v("保存并审核")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "./intoHouse"
    }
  }, [_c('el-button', {
    attrs: {
      "plain": true,
      "type": "info"
    }
  }, [_vm._v("取消")])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.routerID),
      expression: "!this.routerID"
    }],
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.backMedicine
    }
  }, [_vm._v("退药")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a48ccee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pharmacy/newinto.vue
// module id = 1006
// module chunks = 2